

import chunk from 'chunk';

export default {

        props: [],
        components: {

        },
        // scrollToTop: true,   // Currently not working due to a bug in Nuxt. Should have been fixed in latest version of Nuxt
        data : function(){
            return {
                tileCollections: [],
                selectedCollection: 'all',
                backgroundColor: '',
                dividerStyle: '',
            };
        },
        computed: {

            account() {
                return this.$store.getters.getAccount;
            },


            storeLive() {
                return this.$store.getters.getStoreStatus;
            },

            postal_types(){
                return this.$store.getters.getPostageTypes;
            },

            chunkedProducts() {
                if(this.products)
                    return chunk(this.products, 2);
                return [];
            },

            chunkedExperiences() {
                if(this.products)
                    return chunk(this.experienceProducts, 2);
                return [];
            },

            standardProducts(){
                return this.$store.getters.getStandardProducts;
            },

            experienceProducts(){

                return this.$store.getters.getExperienceProducts;
            },

            products(){
                return  this.$store.getters.getProducts.filter(product => {

                    // Don't show past events (tickets)
                    let expired = false;

                    if (product.ProductType && product.ProductType.id == 5) {
                        let now = this.$moment().format();
                        expired = this.$moment(product.TicketProductConfig.event_start_date.replace(/-/g, "/")).isBefore(now, 'day') ? true : false;
                    }

                    return (product.show_on_storefront == true && !expired) || product.bundle == true; 
                });
            },

            bundles(){
                return this.$store.getters.getBundles;
            },

            collections(){
                return this.$store.getters.getCollections;
            },

            collection(){
                let collection = this.$store.getters.getCollectionBySlug(this.$route.params.collection_slug);

                return collection;
            },

            collectionOptions(){
                // Create values for dropdown select. Filter out collections that are not ticked to show on dropdown
                let colls = this.collections
                    .filter(collection => collection.show_on_dropdown)
                    .map(collection => {
                        return { value: collection.slug, label: collection.name};
                    }
                );

                // Add default show-all value to dropdown options
                colls.unshift({ value: "all", label: "Show all" });

                // Create copy so as not to modify original
                return [...colls];
            },

            pageText(){
                return this.$store.getters.getAccountPageText;
            }


        },
        watch : {
            // Re-route depending on what's selected in the dropdown
            selectedCollection : function(value) {
                value === 'all'
                    ? this.$router.push({ name: 'home'})
                    : this.$router.push({ name: 'collection-page', params: {collection_slug: value} });
            }

        },
        created : function(){
            if(process.client)
                this.getStockFile();
        },

        mounted : function(){
            // Enable scroll to top of page
            var body = document.body; // Safari
            var html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified. Therefore, we use the documentElement property for these browsers
            body.scrollTop = 0;
            html.scrollTop = 0;

            // If there is product and no collections, re-route to the product page
            if(this.products && this.products.length == 1 && !this.collections.length){
                this.$router.push({name:'product',params:{product_slug:this.products[0].slug}});
            };

            // If there is one collection and no products, re-route to the collection page
            if(this.collections && this.collections.length == 1 && !this.products.length){
                this.$router.push({name:'collection', params: {collection_slug:this.collections[0].slug}});
            };

            if(this.collections) {

                // Filter out collections not ticked to show on tile
                this.tileCollections = this.collections.filter(collection => collection.show_on_tile);
            };

            if (this.collection) {
                // Set selected dropdown value
                this.selectedCollection = this.collection.slug;
            };

        },

        methods:{
        }

    }

